import React, { Component } from 'react'
import AvatarList from '../avatar_list'
import TeamModal from '../modals/team_modal'
import DropdownButton from 'react-bootstrap/lib/DropdownButton'
import MenuItem from 'react-bootstrap/lib/MenuItem'

class TeamSidebar extends Component {
    constructor(props) {
        super(props)
        this.state = {
            showTeamModal: false,
            showMenu: false,
        }
    }

    toggleTeamModal= () => {
        this.setState({showTeamModal: !this.state.showTeamModal})
    }

    hideDropdown = () => this.setState({ menuOpen: false })
    showDropdown = () => this.setState({ menuOpen: true })

    render () {
        const { team = {}, teamMembers = [], teamInvites=[], reportUser, deleteInvite, handleDisableMember, createInvite, canEditMembership, profile, updateMemberRole } = this.props
        const { showTeamModal } = this.state
        const members = teamMembers
            .filter ( member => (member.isActive))
            .map( member => ({email: member.primaryEmail, name: member.fullName}) )
        return (
            <div className="team-sidebar">
                <div className="team-sidebar-header">
                    <div>{`${members.length} Members`}</div>
                    <div className="option">
                        <DropdownButton
                            className="btn btn-xs btn-options btn-default "
                            id="team-member-dropdown"
                            title={<i className="fa fa-ellipsis-h" aria-hidden="true"></i>}
                            pullRight
                            noCaret
                            bsStyle="default"
                            open={this.props.menuOpen}
                            onToggle={(e) => { }}
                            onClick={(e) => {
                                e.stopPropagation()
                                this.showDropdown()
                            }
                            }>
                            <MenuItem onClick={(e) => {
                                e.stopPropagation()
                                this.toggleTeamModal()
                            }}>
                            Manage Members
                            </MenuItem>
                            <MenuItem onClick={(e) => {
                                e.stopPropagation()
                                reportUser()
                            }}>
                            View Report
                            </MenuItem>
                        </DropdownButton>
                    </div>
                </div>
                <div>
                    <AvatarList
                        teamMembers={members}
                        onClick={reportUser}
                        onCounterClick={this.toggleTeamModal}
                    />
                </div>
                <TeamModal
                    showTeamModal={showTeamModal}
                    accountName={this.props.accountName}
                    trialEnd={this.props.trialEnd}
                    setPaymentModalOpen={this.props.setPaymentModalOpen}
                    toggleTeamModal={this.toggleTeamModal}
                    team={team}
                    teamMembers={teamMembers}
                    teamInvites={teamInvites}
                    reportUser={reportUser}
                    deleteInvite={deleteInvite}
                    createInvite={createInvite}
                    canEditMembership={canEditMembership}
                    handleDisableMember={handleDisableMember}
                    profile={profile}
                    updateMemberRole={updateMemberRole}
                />
            </div>
        )
    }
}

export default TeamSidebar


// WEBPACK FOOTER //
// ./src/components/layout/team_sidebar.jsx